import { Injectable, OnDestroy, NgZone } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HomeMemoryProbeService implements OnDestroy {
  private intervalId: any = null;
  private visHandler: any = null;
  private started = false;
  private t0 = Date.now();
  private mem0: number | null = null;
  
  constructor(private zone: NgZone) {}

  /**
   * Inicia el muestreo si está habilitado por flags (?mem=1 o localStorage.HOME_PROBE='1').
   */
  start(sampleMs = 15000): void {
    if (this.started) return;
    const url = new URL(window.location.href);
  const memParam = url.searchParams.get('mem');
  const domParam = url.searchParams.get('dom');
    const enabled = memParam === '1' || this.safeGetLS('HOME_PROBE') === '1';
    if (!enabled) return;

    this.started = true;
    this.t0 = Date.now();
    this.mem0 = this.getMemoryMB();

  const run = () => {
      // Si la pestaña está oculta, no muestres logs para no contaminar
      if (document.hidden) return;

      const now = Date.now();
      const dt = Math.round((now - this.t0) / 1000);
      const mem = this.getMemoryMB();
      const dMem = mem !== null && this.mem0 !== null ? (mem - this.mem0) : null;

      const perfOpt: any = (window as any).PerformanceOptimizer;
      const perfStats = perfOpt?.getStats ? perfOpt.getStats() : null;

      let gStats: any = null;
      try {
        const GPM: any = (window as any).GlobalPerformanceMonitor;
        if (GPM?.getInstance) {
          gStats = GPM.getInstance().getTracker().getStats();
        }
      } catch {}

      const nodeCount = this.safeNodeCount();
      const videos = document.querySelectorAll('video').length;

      // Contadores DOM opcionales (activar con ?dom=1)
      let dom: any = undefined;
      try {
        const wantDom = domParam === '1' || this.safeGetLS('HOME_PROBE_DOM') === '1';
        if (wantDom) {
          dom = {
            guidedTour: document.querySelectorAll('ngx-guided-tour, .tour-step').length,
            modals: document.querySelectorAll('.modal, .modal-backdrop').length,
            overlays: document.querySelectorAll('.cdk-overlay-container *').length,
            images: document.querySelectorAll('img').length,
            iframes: document.querySelectorAll('iframe').length,
            scripts: document.querySelectorAll('script').length,
          };
        }
      } catch {}

      // En Safari los logs info/log están silenciados si no hay debug; usar warn
  // console.warn('[HOME-PROBE]', { // SILENCIADO
  //   t: dt + 's',
  //   memMB: mem !== null ? Math.round(mem) : 'n/a',
  //   dMemMB: dMem !== null ? Math.round(dMem) : 'n/a',
  //   nodes: nodeCount,
  //   videos,
  //   perfOpt: perfStats,
  //   globalTracker: gStats,
  //   dom,
  // }); // SILENCIADO
    };

    // Ejecutar fuera de Angular para no disparar CD ni que Zone.js marque el timer
    this.zone.runOutsideAngular(() => {
      this.intervalId = setInterval(run, sampleMs);
      // Pausar/reanudar con visibilidad
      this.visHandler = () => {
        try {
          if (document.hidden && this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          } else if (!document.hidden && !this.intervalId) {
            this.intervalId = setInterval(run, sampleMs);
          }
        } catch {}
      };
      document.addEventListener('visibilitychange', this.visHandler, { passive: true });
    });

    // Primer run inmediato para baseline visible
    try { run(); } catch {}
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.visHandler) {
      document.removeEventListener('visibilitychange', this.visHandler);
      this.visHandler = null;
    }
    this.started = false;
  }

  ngOnDestroy(): void {
    this.stop();
  }

  private getMemoryMB(): number | null {
    const mem: any = (performance as any).memory;
    if (mem && typeof mem.usedJSHeapSize === 'number') {
      return mem.usedJSHeapSize / (1024 * 1024);
    }
    return null; // Safari normalmente retorna null
  }

  private safeGetLS(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  }

  private safeNodeCount(): number {
    try { return document.getElementsByTagName('*').length; } catch { return -1; }
  }
}
